<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <rate-control></rate-control>
      <rate-view></rate-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import RateControl from "@/components/rates/rateControl";
import RateView from "@/components/rates/rateView";

export default {
  data() {
    return {
      fid: Number(this.$route.query.fid)
    };
  },
  methods: {},
  mounted() {
    //!!this.fid && (this.client = this.fid)
    if (!!this.fid) {
      ////console.log(this.fid);
      this.client = this.fid;
    }
  },
  computed: {
    //client: RateStore.client
    client: {
      get() {
        return this.$store.state.rates.client;
      },
      set(val) {
        this.$store.commit("rates/setState", { prop: "client", value: val });
      }
    }
  },
  components: {
    RateControl,
    RateView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
